export default __webpack_public_path__ + "static/media/899.153c5304.gif";